import { twMerge } from "tailwind-merge"

type Props = {
  label: string;
  value: string | undefined;
  unit?: string;
  className?: string;
}

export const SingleValue: React.FC<Props> = ({ label, value, unit, className }) => {
  return (
    <div className={twMerge('flex flex-row justify-between md:flex-col', className)}>
      <div className="text-style-label">{label}</div>
      <div className="text-style-item mt-0.5">
        {!!value ? value : "-"}
        {unit && <span className="ml-0.5">{unit}</span>}
      </div>
    </div>
  )
}